import React from 'react';
import { ResourceCard } from 'js/components/pipelines/cards/ResourceCard';
import { RESOURCE_TYPE_CREDENTIALS, RESOURCE_TYPE_SINK } from 'js/constants/resourceTypes';

import './DataCard.css';

function DataSinkCard(props) {
  const { data } = props;
  const isClickable = Boolean(props?.onItemClick) ? ' clickable' : '';

  function onItemClick() {
    if (props.onItemClick) {
      props.onItemClick(RESOURCE_TYPE_SINK, props.data);
    }
  }

  const InnerView = data.data_credentials_id ? (
    <ResourceCard
      data={{
        ...props.credentials[data.data_credentials_id],
        resourceType: RESOURCE_TYPE_CREDENTIALS,
      }}
      connectionInfo={props.connectionInfo}
      resourceType={RESOURCE_TYPE_CREDENTIALS}
      shouldUseResourceIcon
      status="normal"
      size="small"
    />
  ) : null;

  return (
    <ResourceCard
      {...props}
      InnerView={InnerView}
      resourceType={RESOURCE_TYPE_SINK}
      onClick={isClickable ? onItemClick : undefined}
      status="normal"
    />
  );
}

export default DataSinkCard;
